import { render, staticRenderFns } from "./AgendaManageRoute.vue?vue&type=template&id=55d881ed"
import script from "./AgendaManageRoute.vue?vue&type=script&lang=js"
export * from "./AgendaManageRoute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports